import { render, staticRenderFns } from "./DiscoverDesktopFilterReveals.vue?vue&type=template&id=71ce9efd&scoped=true&"
import script from "./DiscoverDesktopFilterReveals.vue?vue&type=script&lang=js&"
export * from "./DiscoverDesktopFilterReveals.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverDesktopFilterReveals.vue?vue&type=style&index=0&id=71ce9efd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ce9efd",
  null
  
)

export default component.exports